import React, { useState, useEffect, useMemo } from 'react';
import { Virtuoso } from 'react-virtuoso';
import {
  Wrapper,
} from './styles';
import {
  useFlightSearchStore,
} from '../../store/flightSearch/flightSearchStore';
import FlightDetails from "./FlightDetails";
import {useStore} from "../../store/global/appStore";


type Props = {
  results?: FlightAggregateResultItem,
  onBookingRedirect: (arg: AirlineResultItem[]) => void
  selectedFlights: AirlineResultItem[],
  onFlightSelect: (arg: AirlineResultItem[]) => void
  cheapestFares: {
    cheapestDeparture: number | null,
    cheapestReturn: number | null
  },
  onLoadMore: () => void,
  loadingMore?: boolean
}
function AvailableFlights({
                            results, onBookingRedirect,
                            selectedFlights, onFlightSelect, cheapestFares, onLoadMore, loadingMore
                          }: Props) {
  const {
    formData,
  } = useFlightSearchStore();
  const { airports } = useStore();

  const resultLists = useMemo<FlightResultItem[]>(() => (results ? results.ResultList : []), [results]);
  const departureFlights: AirlineResultItem[] = resultLists[0]?.ResultList || [];
  const [returnFlights, setReturnFlights] = useState<AirlineResultItem[]>(resultLists[1]?.ResultList || []);
  const cheapestDeparture = cheapestFares?.cheapestDeparture;
  const cheapestReturn = cheapestFares?.cheapestReturn;
  const isOneWay = formData.tripType === 'one_way';

  const handleSelectFlight = (result: AirlineResultItem[]) => {
    if(isOneWay) {
      onBookingRedirect(result);
      return;
    }

    if (!formData.isDomestic) {
        onFlightSelect(result);
        onBookingRedirect(result);
        return;
    }

    if (selectedFlights.length === 0) {
      onFlightSelect(result);
    } else {
      let selections = [...selectedFlights];
      selections[1] = result[0];
      onFlightSelect(selections);
      onBookingRedirect(selections);
    }
  };

  useEffect(() => {
    setReturnFlights(resultLists[1]?.ResultList || []);
  }, [resultLists]);

  const renderFlightItem = (flights: AirlineResultItem[], onlyDepartureSelected: boolean, cheapestFare: number | null) =>
    (index: number, result: AirlineResultItem) => (
      <FlightDetails
        result={result}
        onlyDepartureSelected={onlyDepartureSelected}
        handleSelectFlight={handleSelectFlight}
        cheapestFare={cheapestFare}
        airports={airports}
      />
    );
  
  const ListFooter = () =>
    loadingMore ? (
      <div style={{ padding: '50px 20px', textAlign: 'center' }}>
        Loading more flights...
      </div>
    ) : null;

  return (
    <Wrapper>
      {formData.isDomestic ? (
        <>
          {selectedFlights.length === 0 && (
            <Virtuoso
              useWindowScroll
              data={departureFlights}
              itemContent={renderFlightItem(departureFlights, !isOneWay, cheapestDeparture)}
              endReached={onLoadMore}
              components={{ Footer: ListFooter }}
            />
          )}

          {selectedFlights.length > 0 && (
            <Virtuoso
              useWindowScroll
              data={returnFlights}
              itemContent={renderFlightItem(returnFlights, false, cheapestReturn)}
              endReached={onLoadMore}
              components={{ Footer: ListFooter }}
            />
          )}
        </>
      ) : (
        <Virtuoso
          useWindowScroll
          data={departureFlights}
          itemContent={renderFlightItem(departureFlights, false, cheapestDeparture)}
            endReached={onLoadMore}
            components={{ Footer: ListFooter }}
        />
      )}
    </Wrapper>
  );
}

AvailableFlights.defaultProps = {
  loading: false,
  error: undefined,
  results: undefined,
};
export default AvailableFlights;
